/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useMemo } from 'react';
import { TextField } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Controller, useFieldArray, useFormContext, useWatch } from 'src/common/form';
import { FrequencyType, GroupOperatorType } from 'src/common/enums/categorization-dashboard';
import { Condition } from '../single-condition/condition';
import { groupConditionInitialValue, nestedRuleInitialValue, singleConditionInitialValue } from '../rule/rule.constants';
import { StyledButtonsGroup, StyledFormGroup } from '../rule/rule.styles';
import { Frequency } from '../frequency/frequency';
import { NestedRule } from '../nested-rule-condition/nested-rule';
import { StyledButton } from '../accordion/accordion.styles';
import { StyledCard, StyledContainer, StyledLeftContent, StyledRightContent, StyledRow } from './group.styles';
import { GroupProps } from './group.types';
export const Group = ({
  path,
  sources,
  currentRuleId,
  handleRemoveCondition
}: GroupProps) => {
  const {
    control,
    setValue
  } = useFormContext();
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: `${path}.conditions`
  });
  const [operator, frequency] = useWatch({
    control,
    name: [`${path}.operator`, `${path}.frequency`]
  });
  const operatorOptions = useMemo(() => Object.values(GroupOperatorType).map(t => ({
    label: t,
    value: t
  })), []);
  const selectedType = useMemo(() => operatorOptions.find(option => option.value === operator), [operator, operatorOptions]);
  const handleRemove = (index: number) => {
    remove(index);
    if (fields.length <= 1) {
      handleRemoveCondition();
    }
  };
  const handleAddGroupCondition = () => {
    append(groupConditionInitialValue);
  };
  const handleAddSingleCondition = () => append(singleConditionInitialValue);
  const handleAddNestedRule = () => append(nestedRuleInitialValue);
  const handleAddFrequency = () => {
    setValue(`${path}.frequency`, {
      type: FrequencyType.EVENTS
    });
  };

  // eslint-disable-next-line unicorn/no-useless-undefined
  const handleRemoveFrequency = () => setValue(`${path}.frequency`, undefined);
  const renderCondition = (field: any, index: number) => {
    let element;
    switch (field.type) {
      case 'group':
        {
          element = <Group path={`${path}.conditions.${index}`} sources={sources} handleRemoveCondition={() => handleRemove(index)} />;
          break;
        }
      case 'single':
        {
          element = <Condition path={`${path}.conditions.${index}`} sources={sources} handleRemove={() => handleRemove(index)} />;
          break;
        }
      case 'rule':
        {
          element = <NestedRule path={`${path}.conditions.${index}`} currentRuleId={currentRuleId} handleRemove={() => handleRemove(index)} />;
          break;
        }
      default:
        {
          element = null;
          break;
        }
    }
    return <StyledRow key={field.id} data-sentry-element="StyledRow" data-sentry-component="renderCondition" data-sentry-source-file="group.tsx">{element}</StyledRow>;
  };
  return <StyledRow data-sentry-element="StyledRow" data-sentry-component="Group" data-sentry-source-file="group.tsx">
      <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="group.tsx">
        <StyledCard data-sentry-element="StyledCard" data-sentry-source-file="group.tsx">
          <StyledRow data-sentry-element="StyledRow" data-sentry-source-file="group.tsx">
            <StyledLeftContent operator={operator} data-sentry-element="StyledLeftContent" data-sentry-source-file="group.tsx">
              <Controller control={control} name={`${path}.operator`} render={({
              field: {
                onChange
              }
            }) => <TextField variant="select" isMulti={false} selected={selectedType} isSearchable={false} options={operatorOptions} handleSelection={option => onChange(option?.value)} />} data-sentry-element="Controller" data-sentry-source-file="group.tsx" />
            </StyledLeftContent>
            <StyledRightContent operator={operator} data-sentry-element="StyledRightContent" data-sentry-source-file="group.tsx">
              {fields.map((field, index) => renderCondition(field, index))}
              {frequency && <StyledRow>
                  <Frequency path={path} handleRemove={handleRemoveFrequency} />
                </StyledRow>}
              <StyledRow data-sentry-element="StyledRow" data-sentry-source-file="group.tsx">
                <StyledFormGroup data-sentry-element="StyledFormGroup" data-sentry-source-file="group.tsx">
                  <StyledButtonsGroup data-sentry-element="StyledButtonsGroup" data-sentry-source-file="group.tsx">
                    <StyledButton variant="text" color="secondary" size="small" onClick={handleAddGroupCondition} data-sentry-element="StyledButton" data-sentry-source-file="group.tsx">
                      <FontAwesomeIcon icon={faPlus} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="group.tsx" />
                      Add group
                    </StyledButton>

                    <StyledButton variant="text" color="secondary" size="small" onClick={handleAddSingleCondition} data-sentry-element="StyledButton" data-sentry-source-file="group.tsx">
                      <FontAwesomeIcon icon={faPlus} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="group.tsx" />
                      Add condition
                    </StyledButton>

                    <StyledButton variant="text" color="secondary" size="small" onClick={handleAddNestedRule} data-sentry-element="StyledButton" data-sentry-source-file="group.tsx">
                      <FontAwesomeIcon icon={faPlus} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="group.tsx" />
                      Add nested rule
                    </StyledButton>

                    <StyledButton variant="text" color="secondary" size="small" isDisabled={!!frequency} onClick={handleAddFrequency} data-sentry-element="StyledButton" data-sentry-source-file="group.tsx">
                      <FontAwesomeIcon icon={faPlus} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="group.tsx" /> Add frequency
                    </StyledButton>
                  </StyledButtonsGroup>
                </StyledFormGroup>
              </StyledRow>
            </StyledRightContent>
          </StyledRow>
        </StyledCard>
      </StyledContainer>
    </StyledRow>;
};